import { render, staticRenderFns } from "./VerticalNavMenuSectionTitle.vue?vue&type=template&id=d9cb5a94&scoped=true&"
import script from "./VerticalNavMenuSectionTitle.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuSectionTitle.vue?vue&type=style&index=0&id=d9cb5a94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cb5a94",
  null
  
)

export default component.exports